<template>
  <div>
    <AutoComplete ref="target" :title="title" :value.sync="internalValue" :required="required" :queryProvider="(search, perPage, currentPage)=>queryProvider(search, perPage, currentPage)"  :editor="editor" :enabled="enabled" :isDirectEditEnabled="isDirectEditEnabled" :isLink="true" :tooltip="tooltip" @linkClicked="onLinkClicked"  :widths="[100,240,100]" :captions="['案件番号','得意先名','案件名']" :path="$api.useProjectItemFunction ? '/sales/ProjectItem' : ''">
      <span slot="col0" slot-scope="{item}">{{item.projectItemNo}}</span>
      <span slot="col1"  slot-scope="{item}">{{item.counterprtName}}</span>      
      <span slot="col2"  slot-scope="{item}">{{item.name}}</span>      
      <!-- <span slot="col2"  slot-scope="{item}">{{item.counterprt.name}}</span>   -->
      <b-button slot="buttons" slot-scope="{value}" v-if="editor && $api.useProjectItemFunction" @click="onFuncClicked" :disabled="$api.perms.hasMenuPermission('master.menu_counterpart.edit')==false" >
        <i class="material-symbols-outlined small valign" style="pointer-events:none;" ref="popupButton" >{{value ? 'settings':'docs_add_on'}}</i>         <!--slot-scopeのvalueにしないとリアクティブにならない(原因不明)-->      
      </b-button>          
    </AutoComplete>
    <PopupEditor v-model="showEditor" title="案件一覧" @closing="onEditorClosing" mode="editor" :isInsertMode="value ? false:true">
      <ProjectItem slot-scope={popup} :popup="popup" :projectItemNo="value ? value.projectItemNo : null"  ref="editor"/>
    </PopupEditor>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcProjectItem extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop() public tooltip: string;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
  }
    destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }

  public queryProvider(search:string, perPage:number, currentPage:number){
    var query = new Common.ProjectItemMasterQuery();
    query.search = search ? search : '';
    query.perPage = perPage;
    query.currentPage = currentPage;
    return query;
  }

  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');
  }


  public onLinkClicked(){
    this.onFuncClicked();
  }    

  public showEditor = false;
  public onFuncClicked(){
    this.showEditor = true;
  }

  public onEditorClosing(arg : any){
    var obj = ((this.$refs.editor as Components.ProjectItem).$refs.mainList as Components.ListView).selected;
    if (!obj.projectItemNo) return; //未保存の場合はキャンセル可

    //オブジェクトを更新する
    this.$emit('update:value', obj);    
    this.$emit('closed', obj);        
  }
}
  
</script>
